<template>
  <div id="newPurchaseOrder">
    <el-row class="clearfix">
      <el-col class="fl" :span="2">
        <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
      </el-col>
      <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
    </el-row>
    <el-col class="fl searthPart" style="width: 17%;">
      <p class="headerT" >采购订单信息</p>
      <el-form ref="purchaseOrderForm" :model="purchaseOrderForm" label-width="80px" :label-position="labelPosition" :rules="purchaseOrderFormRules">
        <el-form-item label="供应商"  prop="supplierName">
          <el-select filterable v-model="purchaseOrderForm.supplierName" placeholder="请选择供应商" style="width: 100%;" clearable @change="getSupplier">
            <el-option v-for="(item,index) in supplierList" 
              :label="item.supplierName" 
              :value="item.id" 
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购日期"  prop="purchaseTime">
          <el-date-picker style="width: 100%;"
            v-model="purchaseOrderForm.purchaseTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="交货日期" prop="aogTime">
          <el-date-picker style="width: 100%;"
            v-model="purchaseOrderForm.aogTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col class="fr" style="width: 81%;">
      <!-- <p class="headerT">供应商信息详情</p>:summary-method="getSummaries"  show-summary-->
      <p class="headerT fl">订单详情</p>
      <el-button  size="small"  type="success" class="fr" @click="newMater()" style="margin-top: 15px;">新建明细</el-button>
      <el-card class="box-card fr" style="width: 100%;">
        <el-table
          :data="returnData"
          border
          :header-cell-style="{'text-align':'center'}"
          style="width: 100%"
          >
          <el-table-column
            align="center"
            type="index"
            width="50"
            label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="50">
            <template slot-scope="scope">
              <el-button @click.stop="deleteRow(scope.$index, returnData)" type="text" size="small">移除</el-button>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialCode"
            label="物料编号">
            <!-- <template slot-scope="scope">
              <span>{{ mapForChannel[scope.row.materialCoding] }}</span>
           </template> -->
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialName"
            label="物料名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="number"
            label="采购数量">
            <template slot-scope="scope">
              <el-input-number v-show="scope.row.number" controls-position="right" size="small" v-model.trim="scope.row.number" @change="changeNumber()" :min="1"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="采购单价(元)">
            <template slot-scope="scope">
              <el-input v-show="scope.row.price" size="small" v-model.trim="scope.row.price" @change="changeAmount()"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="amount"
            label="合计金额">
            <template slot-scope="scope">
             {{scope.row.amount = scope.row.price * scope.row.number}}
           </template>
          </el-table-column>
        </el-table>
        <div class="totalDiv">
          <small>数量：</small>
          <strong>{{totalCount}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;
          <small>总计：</small>
          <strong>{{totalMoney}}</strong> 元
        </div>
      </el-card>
      
      <el-dialog title="新建物料信息" :visible.sync="dislogMater" :close-on-click-modal="false" width="800px"  @close="emptyNew()">
        <el-row>
          <el-col>
            <ul class="clearfix" style="margin-bottom: 15px;">
              <span class="fl headerSpan">品牌</span>
              <li class="fl listPart" v-for="(item,index) in brandLists" :key="index" @click="selectBrand(item,index)" v-bind:class="{active:activeBrandIndex===index}">{{item.brandName}}</li>
            </ul>
            <transition name="fade" mode="out-in" appear>
              <ul class="clearfix" style="margin-bottom: 15px;" v-if="categoryLists.length !== 0 ">
                <span class="fl headerSpan">品类</span>
                <li @click="selectCategory(item,index)" class="fl listPart" v-for="(item,index) in categoryLists" :key="index" v-bind:class="{active:activeCategoryIndex===index}">{{item.categoryName}}</li>
              </ul>
            </transition>
            <transition name="fade" mode="out-in" appear>
              <ul class="clearfix" style="margin-bottom: 15px;" v-if="modelLists.length !== 0 ">
                <span class="fl headerSpan">型号</span>
                <li @click="selectModel(item,index)" v-bind:class="{active:activeModelIndex===index}" class="fl listPart" v-for="(item,index) in modelLists" :key="index">{{item.modelName}}</li>
              </ul>
            </transition>
          </el-col>
        </el-row>
        <el-table
          :data="newData"
          border
          :header-cell-style="{'text-align':'center'}"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            align="center"
            prop="brandId"
            label="品牌">
          </el-table-column>
          <el-table-column
            align="center"
            prop="categoryId"
            label="品类">
          </el-table-column>
          <el-table-column
            align="center"
            prop="modelName"
            label="型号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialCode"
            label="物料编号">
            <!-- <template slot-scope="scope">
              <span>{{ mapForChannel[scope.row.materialCoding] }}</span>
           </template> -->
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialName"
            label="物料名称">
          </el-table-column>
          <el-table-column
            align="center"
            type="selection"
            width="55">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="addEventFormSubmitBtn()">添加</el-button>
          <el-button @click="emptyNew()">取 消</el-button>
        </span>
      </el-dialog>
      <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="saveOrder()">提交</el-button>
      <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
        {{pageStatus}}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item>
          <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消新建</el-button>
    </el-col>
    
  </div>
</template>

<script>
 import {
    supplierList,getMaterialList,purchaseOrdersAdd,selectAllBrand,selectCategory,selectModel,selectMaterialManagements
  } from "../../api/api";
 import {getPermission} from '../../api/authRequest'
 export default {
    name: 'newPurchaseOrder',
    data () {
      return {
        totalCount:0,
        totalMoney:0,
        MaterialLists:[],
        defaultBrandId:'',
        defaultCategoryId:'',
        defaultModelId:'',
        brandLists:'',
        categoryLists:'',
        modelLists:'',
        activeBrandIndex:"",
        activeCategoryIndex:"",
        activeModelIndex:"",
        pageStatus:'留在当前页面',
        saveStatus:'QR',
        materialCoding:'',
        materNumberList:[],
        dislogMater:false,
        supplierList:[],
        orderStates:[{name:'订单详情'}],
        labelPosition:'left',
        purchaseOrderForm:{
          supplier: '',
          supplierName:'',
          paymentTime: '',
          purchaseTime: '',
          aogTime: '',
        },
        purchaseOrderFormRules:{//validateRoleName
          supplierName: [{ required: true, message: "请输入供应商名称", trigger: "submit" }],
          aogTime: [{ required: true, message: "请输入交货日期", trigger: "submit" }],
          purchaseTime: [{ required: true, message: "请输入采购日期", trigger: "submit" }],
        },
        newData: [],
        returnData: [],
        materForm:{
          materialCoding:'',
          materialName:'',
          number: '',
          amount:'',
          price:'',
          backUpPrice:''
        },
        materFormRules:{
          materialCoding: [{ required: true, message: "请选择物料编号", trigger: "submit" }],
          materialName: [{ required: true, message: "请输入物料名称", trigger: "submit" }],
          price: [{ required: true, message: "请输入采购单价", trigger: "submit" }],
        },
        backupAmout:0,
        amout: 0,
        sum: 0,
        price: '',
        multipleSelection:[],
      }
    },
    created:function(){
      
    },
    mounted () {
      this.getsupplierLists();
      this.getMaterialManagementList();
    },
    methods: {
        //提交
        saveOrder(){
           this.saveStatus = 'YQR';
           console.log(this.purchaseOrderForm)
           console.log(this.returnData)
            if (this.purchaseOrderForm.supplier==""||this.purchaseOrderForm.supplierName==""||this.purchaseOrderForm.paymentTime=="") {
                this.$message({
                    message: '请选择供应商！',
                    type: 'warning'
                });
            }else if(this.purchaseOrderForm.purchaseTime==""){
                this.$message({
                    message: '请选择采购日期！',
                    type: 'warning'
                });
            }else if(this.purchaseOrderForm.aogTime==""){
                this.$message({
                    message: '请选择预期交货日期！',
                    type: 'warning'
                });
            }else if(this.returnData.length == 0){
                this.$message({
                    message: '请新建物料明细并选择，再提交！',
                    type: 'warning'
                });
            }else{
                let para={
                      supplier: this.purchaseOrderForm.supplier,
                      supplierName: this.purchaseOrderForm.supplierName,
                      paymentTime: this.purchaseOrderForm.paymentTime,
                      purchaseTime: this.purchaseOrderForm.purchaseTime,
                      aogTime: this.purchaseOrderForm.aogTime,
                      status: this.saveStatus,
                      amout: this.totalMoney,
                      sum: this.totalCount,
                      purchaseDetails: this.returnData,
                      modelId: this.defaultModelId
                }
                console.log(para)
                purchaseOrdersAdd(para).then(res => {
                    if (res.data.status==100) {
                        if (this.pageStatus == '留在当前页面') {
                            this.dialogVisible = false
                            this.purchaseOrderForm = {}
                            this.returnData = []
                            this.$message({
                                message: '新建成功',
                                type: "success"
                            });
                        }else{
                            this.tabRemove(this.$route.path)
                            this.$router.replace({
                                path:'/purchaseOrderManage'
                            })
                            this.$message({
                                message: '新建成功',
                                type: "success"
                            });
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            }
            
        },
        //获取物料编码 
        getMaterialManagementList() {
            selectMaterialManagements().then(res => {
              if (res.data.status==100) {
                this.MaterialLists = res.data.results
                // console.log(this.MaterialLists)
              }else{
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
        },
        //获取选中型号的物料数据 => 数组
        handleSelectionChange(val) {
            console.log(val)
            if(val != []){
                this.multipleSelection = val;
            }
        },
        toThousands(num) {
            // this.materForm.backUpPrice = num
            alert(num)
            num = num.toString().replace(/\$|\,/g,'');
            if(isNaN(num))
                num = "0";
            var sign = (num == (num = Math.abs(num)));
            num = Math.floor(num*100+0.50000000001);
            var cents = num%100;
            num = Math.floor(num/100).toString();
            if(cents<10)
            cents = "0" + cents;
            for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
            num = num.substring(0,num.length-(4*i+3))+','+
            num.substring(num.length-(4*i+3));
            // this.materForm.price = (((sign)?'':'-') + num + '.' + cents)
            return (((sign)?'':'-') + num + '.' + cents);
        },
        toThousands2(num) {
            // this.materForm.backUpPrice = num
            num = num.toString().replace(/\$|\,/g,'');
            if(isNaN(num))
                num = "0";
            var sign = (num == (num = Math.abs(num)));
            num = Math.floor(num*100+0.50000000001);
            var cents = num%100;
            num = Math.floor(num/100).toString();
            if(cents<10)
            cents = "0" + cents;
            for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
            num = num.substring(0,num.length-(4*i+3))+','+
            num.substring(num.length-(4*i+3));
            // this.materForm.price = (((sign)?'':'-') + num + '.' + cents)
            return (((sign)?'':'-') + num + '.' + cents);
        },
        tabRemove (targetName) {
              // 首页不可删除
              if(targetName == '/') {
                return;
              }
              //将该tab从options里移除
              this.$store.commit('delete_tabs', targetName);
              ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
              if (this.activeIndex === targetName) {
                // 设置当前激活的路由
                if (this.options && this.options.length >= 1) {
                  this.$store.commit('set_active_index', this.options[this.options.length-1].route);
                  this.$router.push({path: this.activeIndex});
                } else {
                  this.$router.push({path: '/welcome'});
                }
              }
        },
        //获取供应商下拉列表
        getsupplierLists() {
            supplierList().then(res => {
              if (res.data.status==100) {
                this.supplierList = res.data.results

              }else{
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
        },
        //获取供应商ID及信息
        getSupplier(e){
            for (var orderId in this.supplierList) {
              if (e === this.supplierList[orderId].id) {
                this.purchaseOrderForm.supplier = this.supplierList[orderId].id
                this.purchaseOrderForm.supplierName = this.supplierList[orderId].supplierName
                this.purchaseOrderForm.paymentTime = this.supplierList[orderId].allottedTime
              }
            }
            // sessionStorage.setItem('saveOrderForm', JSON.stringify(this.purchaseOrderForm));
        },
        closeSave(){
            this.pageStatus = "离开当前页面"
        },
        goOnSave(){
            this.pageStatus = "留在当前页面"
        },
        //查询品牌or获取品牌
        getBrandLists() {
            selectAllBrand().then(res => {
              if (res.data.status==100) {
                this.brandLists = res.data.results
                // this.defaultBrandId = res.data.results[0].brandId
                // console.log(this.defaultBrandId)
                // this.getCategoryList(this.defaultBrandId)
              }else{
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
        },
        //选中品牌
        selectBrand(item,index) {
            this.activeBrandIndex = index
            this.activeCategoryIndex = ""
            this.activeModelIndex = ""

            this.defaultBrandId = Object.assign({}, item).brandId
            // console.log(this.defaultBrandId)
            this.getCategoryList(this.defaultBrandId)
        },
        //获取品类
        getCategoryList(id){
            const brandId = id
            const brandData = {brandId:brandId}
            selectCategory(brandData).then((res) => {
              if (res.data.status == 100) {
                this.categoryLists = res.data.results
                // this.defaultCategoryId = res.data.results[0].categoryId
                // console.log(this.defaultCategoryId)
                // this.getModelList(this.defaultBrandId,this.defaultCategoryId)
              }else{
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            }).catch((error) => {
              this.$Message.error(error.message);
            })
        },
        //选中品类
        selectCategory(item,index) {
            this.activeCategoryIndex = index
            this.activeModelIndex = ""
            this.defaultCategoryId = Object.assign({}, item).categoryId
            this.getModelList(this.defaultBrandId,this.defaultCategoryId)
        },
        //获取型号
        getModelList(id1,id2){
            let para = {
              brandId:id1,
              categoryId:id2,
            }
            selectModel(para).then(res => {
              if (res.data.status==100) {
                this.modelLists = res.data.results
                // this.defaultModelId = res.data.results[0].modelId
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
        },
        //选中型号
        selectModel(item,index) {
            this.activeModelIndex = index
            this.defaultModelId = Object.assign({}, item).modelId
            this.getMaterNumberList()
        },
        //获取物料编号
        getMaterNumberList(){
            let para={
               brandId: this.defaultBrandId,
            
               categoryId:this.defaultCategoryId,
            
               modelId: this.defaultModelId,
            }
            getMaterialList(para).then(res => {
              if (res.data.status==100) {
                this.newData = res.data.results
              }else{
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
        },
        //提交添加明细
        addEventFormSubmitBtn() {
            let isHave = false
              // 判断是否这个商品已经存在于订单列表
            for (var i = 0; i < this.returnData.length; i++) {
              if (this.returnData[i].materialCoding === this.multipleSelection[i].materialCoding) {
                isHave = true // 存在
              }
            }
            // console.log(isHave)
            // // 根据isHave的值判断订单列表中是否已经有此商品
            if (isHave) {
              // 存在就提示直接在列表中手动输入
              this.$message({
                message: "列表中已存在此项，请手动输入数量",
                type: "error"
              });
              this.emptyNew()
            } else {
              // 不存在就推入数组
                this.multipleSelection.forEach((item,index,array) =>{
                 if(array.indexOf(item) === index) {
                  this.returnData.push(
                    { materialCoding: item.materialCoding,
                      materialCode:item.materialCode,
                      materialName: item.materialName,
                      modelId:item.modelId,
                      modelName:item.modelName,
                      number:1,
                      price:1,
                      // amount:item.number*item.price
                    }
                  )
                }
              })
              this.emptyNew()
              this.getAllMoney()
            }
            this.dislogMater = false
        },
        changeNumber(){
            this.getAllMoney();
        },
        changeAmount(){
            this.getAllMoney();

        },
        // 汇总数量和金额
        getAllMoney() {
            this.totalCount = 0
            this.totalMoney = 0
            if (this.returnData) {
              this.returnData.forEach(element => {
                this.totalCount += element.number
                this.totalMoney = this.totalMoney + element.price * element.number
              })
            }
        },
        //取消新建
        cancelOrder(){
            this.tabRemove(this.$route.path)
            this.$router.replace({
              path:'/purchaseOrderManage'
            })
        },
        //清空dialogValue
        emptyNew() {
            this.dislogMater = false
            this.newData = []
            this.activeBrandIndex = ""
            this.categoryLists = ""
            this.modelLists = ""
        },
        newMater(){
            this.dislogMater = true
            this.getBrandLists();
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = '合计';
                return;
              }
              if (index === 5) {
                return;
              }

              const values = data.map(item => Number(item[column.property]));
              if (!values.every(value => isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index] += '';
              } else {
                sums[index] = '';
              }
            });
            // sums[6] = this.toThousands2(sums[6]);
            // if (sums[6] > 0) {
            //   sums[6] = this.toThousands2(sums[6]);
            // }
            return sums;
        },
        //移除订单
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        //返回上一页
        backGo() {
            this.$router.push({
              path:'/purchaseOrderManage'
            })
        },
        refresh() {
            Object.keys(this.purchaseOrderForm).forEach(key => this.purchaseOrderForm[key]= '');
            this.returnData = [];
        },
    },
    computed: {
      mapForChannel () {
        // console.log(this.MaterialLists)
        let map = []
        if (this.MaterialLists && this.MaterialLists.length) {
          this.MaterialLists.forEach(item => {
            map[item.materialCoding] = item.materialCode
          })
        }
        return map
      },
    },
    watch: {
    }
  }
</script>

<style type="text/css" lang="scss" scoped>
  #newPurchaseOrder{
    font-size: 14px;
    .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
    .headerT{font-size: 16px;margin:20px 0 15px 0;}
    .headerSpan{margin-right: 20px;}
    .listPart{border:1px solid #c6c6c6;margin:-8px 15px 10px 0;border-radius: 5px;text-align: center;position: relative;z-index: 0;cursor: pointer;padding: 5px 10px;}
    li.active{background-color:#1abc9c;color:#fff;border-color: #1abc9c;}
    .activeBtn{background-color: #1abc9c;color:#fff;}
    .el-step__line{background-color: #1abc9c;}
    .el-step__icon-inner{color:#1abc9c;}
    .el-step__icon.is-text{border-color: #1abc9c;}
    .totalDiv{
      height: auto;
      overflow: hidden;
      text-align: right;
      font-size: 16px;
      background-color: #fff;
      border-bottom: 1px solid #e5e9f2;
      padding: 10px;
    }
  }
  
</style>



// WEBPACK FOOTER //
// newPurchaseOrder.vue?d8d34274